function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

//Slidecart QTY issue fix start //

var slideCartButton;

function checkButtonStyleAndSetTimeout() {
  $('.hs-cart-plus-minus').css('pointer-events', 'none');
    var $button = $('.hs-checkout-purchase');
    var buttonOpacity = parseFloat($button.css('opacity'));

    var buttonPointerEvents = $button.css('pointer-events');
    if ($button.attr('style') == '') {
        $('.hs-cart-plus-minus').css('pointer-events', 'auto');
        $('[data-quantity="2"] .hs-inc, .hs-cart-plus-minus input').css('pointer-events', 'none');
    } else {
      $('.hs-cart-plus-minus').css('pointer-events', 'none');
      clearInterval(slideCartButton); // Stop the interval when the button is not active
    }
}

$(document).on('click', '.hs-qtybutton', function() {
    if (slideCartButton) {
        clearInterval(slideCartButton); // Clear any existing interval
    }
    slideCartButton = setInterval(checkButtonStyleAndSetTimeout, 500);
});

//Slidecart QTY issue fix end //

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

// function pauseAllMedia() {
//   document.querySelectorAll('.js-youtube').forEach((video) => {
//     video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
//   });
//   document.querySelectorAll('.js-vimeo').forEach((video) => {
//     video.contentWindow.postMessage('{"method":"pause"}', '*');
//   });
//   document.querySelectorAll('video').forEach((video) => video.pause());
//   document.querySelectorAll('product-model').forEach((model) => {
//     if (model.modelViewerUI) model.modelViewerUI.pause();
//   });
// }

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}',
      '*'
    );
  });

  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });

  document.querySelectorAll('video').forEach((video) => {
    // Don't pause these videos
    if (
      video.id !== 'ellen-video' && video.id !== 'clinic-before-after-video' && video.id !== 'lp-result-video' &&
      !video.classList.contains('price-video-section')
    ) {
      video.pause();
    }
  });

  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  // Check if trapFocusHandlers is defined and contains the necessary handlers
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

$(document).keyup(function (e) {
    if (e.key === "Escape") {
        $(".includespopup .popup-close .close, .whats-included-popup .popup-close .close").trigger("click");
        if($('.modal.fade').hasClass('show')){$('.modal.fade button.close').trigger("click");}
    }
});

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }
    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header ||  document.querySelector('.brand-header') ||  document.getElementById('shopify-section-header') || document.getElementById('shopify-section-lp-header') || document.getElementById('shopify-section-lp-tv-header') || document.getElementById('shopify-section-lp-emd-header') || document.getElementById('shopify-section-collection-based-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
     document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button)
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;
    const isThumbnailSlider = this.closest('.product--thumbnail_slider');
    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      if(!isThumbnailSlider) this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      if(!isThumbnailSlider) this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateLineItemId(productForm,variantId){
    const line_item_id = productForm.querySelector('[name="properties[_line_item_id]"]');
    if(line_item_id){
          const line_item_id_subcription = productForm.querySelector('[name="line_item_id_subcription"]');
          const line_item_id_one_time = productForm.querySelector('[name="line_item_id_one_time"]');

          const line_item_id_subcription_value = line_item_id_subcription.value;
          const line_item_id_one_time_value = line_item_id_one_time.value;
          const line_item_id_value = line_item_id.value;

          const newVariant = variantId;
          const line_item_id_subcription_updatedValue = line_item_id_subcription_value.replace(/^[^:]+/, newVariant);
          const line_item_id_one_time_updatedValue = line_item_id_one_time_value.replace(/^[^:]+/, newVariant);
          const  line_item_id_updatedValue = line_item_id_value.replace(/^[^:]+/, newVariant);

          line_item_id_subcription.value = line_item_id_subcription_updatedValue;
          line_item_id_one_time.value = line_item_id_one_time_updatedValue;
          line_item_id.value = line_item_id_updatedValue;
    }
  }

  updateVariantInput() {

      var productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
      );
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;

        this.updateLineItemId(productForm,this.currentVariant.id)

        // Dynamic inputs based on variant ID
        const preupsellVariant = productForm.querySelector(`[name="_preupsell_variants_${this.currentVariant.id}"]`);
        const preupsellDefault = productForm.querySelector(`[name="_preupsell_variants_default"]`);
        const targetInput = productForm.querySelector('[name="properties[_preupsell_variants]"]');

        if (targetInput) {
          targetInput.value = preupsellVariant?.value || preupsellDefault?.value || '';
        }

        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));

        try {
            const qtyError = productForm.querySelector('.qty-error');
            if (qtyError !== null) {
              qtyError.remove();
              $('.qty-error').remove();
            }
          } catch (error) {
            console.error('Error removing qty-error:', error);
          }
          try {
            const ingPopup = productForm.closest('.ingpopup');
            if (ingPopup) {
              const shopqtyErrors = ingPopup.querySelectorAll('.shop-qty-error');
              shopqtyErrors.forEach((shopqtyError) => {
                shopqtyError.remove();
              });
            }
          } catch (error) {
            console.log(error);
          }
      });
  }


  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

(function () {

    function initRechargeWidget() {
        const widget = document.querySelector('.rc-widget__root');

        if (!widget) {
            setTimeout(initRechargeWidget, 200);
            return;
        }

        function checkReady() {

            /* ---------- One-Time Purchase ---------- */

            const oneTimeLabel = widget.querySelector('.rc-selection__onetime');

            if (oneTimeLabel) {

                const spans = [...oneTimeLabel.querySelectorAll(':scope > .rc-purchase-option__selector')];

                // Keep only non-empty labels
                const filledSpans = spans.filter(function (span) {
                    return span.textContent.trim() !== '';
                });

                const hasPrice = /\$\d/.test(oneTimeLabel.textContent);
                const hasText = oneTimeLabel.textContent.indexOf('One-time Purchase') > -1;

                if (filledSpans.length >= 2 && hasPrice && hasText) {
                    oneTimeLabel.classList.add('ready');
                } else {
                    oneTimeLabel.classList.remove('ready');
                }
            }

            /* ---------- Subscription ---------- */

            const subscriptionLabel = widget.querySelector('.rc-purchase-option__subscription');

            if (subscriptionLabel) {

                const price = subscriptionLabel.querySelector('.rc-price');
                const sellingPlan = subscriptionLabel.querySelector('rc-selling-plans');

                if (
                    price &&
                    price.textContent.trim() !== '' &&
                    sellingPlan
                ) {
                    subscriptionLabel.classList.add('subscription-ready');
                } else {
                    subscriptionLabel.classList.remove('subscription-ready');
                }
            }
        }

        checkReady();

        const observer = new MutationObserver(function () {
            checkReady();
        });

        observer.observe(widget, {
            childList: true,
            subtree: true,
            characterData: true
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initRechargeWidget);
    } else {
        initRechargeWidget();
    }

})();

//Subscription section Recharge app flow modiifed //
function oneTimewknd(){
  jQuery.getJSON('/cart.js', function(cart) {
    if( cart.attributes.current_campaign_id == "10poffwknd"){
       $(".rc-purchase-option__selected.rc-selection__onetime").addClass('wkndten');
      $(".rc-selection__onetime").addClass('wkndten');
   }
  });
}
// function rcWidjectCustomize(skipIfLoggedIn=true) {
//   // If the user is logged in, abort widget customization because we handle that elsewhere.
//   if (skipIfLoggedIn && window.SESSION_CUSTOMER_CACHE_KEY) {
//     return;
//   }
//   setTimeout(function(){
//     document.querySelectorAll('.rc-purchase-option__input').forEach((radio) => {
//       if (radio.dataset.ariaApplied) return;
//       if (radio.value === 'onetime') {
//         radio.setAttribute('aria-label', 'onetime-purchase-select');
//       } else if (radio.value === 'subscription') {
//         radio.setAttribute('aria-label', 'subscription-purchase-select');
//       }
//       radio.dataset.ariaApplied = 'true';
//     });
//     var oneTime = $('.rc-selection__onetime .rc-purchase-option__selector').text();
//     var splitedPrice = oneTime.split("$");
//     var finalPrice = splitedPrice.pop();
//       if($(".rc-purchase-option__selected.rc-selection__onetime, .rc-selection__onetime").hasClass("wkndten")){
//         setTimeout(function(){
//            $(".rc-selection__onetime").append('<p class="get-offer">Get 10% off at checkout today</p>');
//         },300)
//      }
//     var originalPrice = $('.product__info-wrapper .price__container .price__sale s.price-item--regular').text().trim();
//     // Remove any non-numeric characters and whitespace
//     var cleanedPrice = originalPrice.replace(/[^0-9.]/g, '');
//     var formattedPrice = "$" + parseFloat(cleanedPrice).toFixed(2);

//     if($('.price-section .offer-price-block').length > 0){
//       var offerPercentage = $('.offer-price-block .offer-percentage').text();
//       splitedPrice = splitedPrice + ': <b>SAVE '+offerPercentage+'%</b>';
//       var originalPrice = $('.offer-price-block .original-price-item').text();
//       var originalPriceValue = originalPrice.replace(/[^0-9.]/g, '');
//       var orginalPriceOneTime = "$" + parseFloat(originalPriceValue).toFixed(2);
//       var offerPrice = $('.offer-price-block .offer-price-item').text();

//       finalPrice = '<s>'+orginalPriceOneTime+'</s><span class="offer-price">'+offerPrice+'</span>';
//       var combinedContent = 'One-Time Purchase ' + splitedPrice;
//       var stickyfooterstrikeprice = "";
//       if( originalPrice != ''){ stickyfooterstrikeprice = '<s>'+formattedPrice+'</s>'; }
//       $('.pdp-sticky-footer .sticky-footer-price').html(stickyfooterstrikeprice + $('.rc-purchase-option__subscription .rc-price').text());
//     }else{ finalPrice = '$'+ finalPrice;
//         var stickyfooterstrikeprice = "";
//         if( originalPrice != ''){ stickyfooterstrikeprice = '<s>'+formattedPrice+'</s>'; }
//         $('.pdp-sticky-footer .sticky-footer-price').html(stickyfooterstrikeprice + $('.rc-purchase-option__subscription .rc-price').text());
//     }
//     $(".rc-selection__onetime").insertAfter("div.rc-template__radio");
//     $('.rc-selection__onetime .rc-purchase-option__selector').clone().insertAfter('.rc-selection__onetime span.rc-purchase-option__selector').html(splitedPrice);
//     $('.custom-onetime-radio .rc-selection__onetime-label').html(combinedContent);
//     $('.rc-selection__onetime span.rc-purchase-option__selector:nth-child(2)').html(finalPrice);
//     $('.rc-selling-plans').insertAfter('.rc-purchase-option__subscription .rc-purchase-option__selector');
//     $('.save-and-subscribe-pdp').insertAfter('.rc-purchase-option__subscription .rc-purchase-option__selector');
//    if( originalPrice != ''){
//      $('.rc-purchase-option__subscription .rc-price').html('<s>'+formattedPrice+'</s>'+$('.rc-purchase-option__subscription .rc-price').text());
//    }
//     $('.shipping-frequency-section').clone().insertAfter('.rc-selling-plans rc-selling-plans, .rc-selling-plans .rc-selling-plans-dropdown .rc-selling-plans-dropdown__select');
//     $('.technology-section').insertAfter('#benefits');
//     $('.rc-widget__root .save-and-subscribe-pdp').css('display','flex');

//     if($('.recharge-subscription-widget .rc-widget__root').length == 0){
//       function formattedPriceFinal(selector, prefix) {
//         var priceText = $(selector).text();
//         var priceValue = parseFloat(priceText.replace(/[^0-9.]/g, ''));
//         var FianlFormattedPrice = prefix + priceValue.toFixed(2);
//         return FianlFormattedPrice;
//       }
//       var offOneTimePriceFinal = formattedPriceFinal('.offer-price-block .offer-price-item', '$');
//       var offOneTimePriceSticky = formattedPriceFinal('.offer-price-block s.original-price-item', '$');
//       var CustomFormattedPrice = formattedPriceFinal('.product__info-wrapper .price-section .price__container .price__sale .price-item', '$');

//       if($('.offer-price-block').length > 0){
//         $('.custom-onetime-radio .price-label').html('<s>'+ offOneTimePriceSticky +'</s>'+offOneTimePriceFinal);
//         $('.pdp-sticky-footer .sticky-footer-price').html('<s>'+offOneTimePriceSticky+'</s>'+ offOneTimePriceFinal);
//       }else{
//         $('.custom-onetime-radio .price-label').html('<s>'+ $('.product__info-wrapper .price__container .price-section s.price-item--regular').text() +'</s>'+CustomFormattedPrice);
//         //$('.custom-onetime-radio .price-label').html('<s>'+ $('.product__info-wrapper .price__container .price-section s.price-item--regular').text() +'</s>'+$('.product__info-wrapper .price-section .price__container .price__sale .price-item').text());
//         $('.pdp-sticky-footer .sticky-footer-price').html('<s>'+ $('.product__info-wrapper .price__container .price-section s.price-item--regular').text()+'</s>'+CustomFormattedPrice);
//       }          
//     }
//   },2500);
// };


// function rcWidjectCustomize(skipIfLoggedIn = true) {

//   // Skip customization for logged-in customers
//   if (skipIfLoggedIn && window.SESSION_CUSTOMER_CACHE_KEY) {
//     return;
//   }

//   var maxAttempts = 50;
//   var attempt = 0;

//   function initRechargeWidget() {

//     attempt++;

//     var rechargeWidget = document.querySelector(
//       'recharge-subscription-widget'
//     );

//     if (!rechargeWidget || !rechargeWidget.shadowRoot) {

//       if (attempt < maxAttempts) {
//         setTimeout(initRechargeWidget, 200);
//       }

//       return;
//     }

//     var shadowRoot = rechargeWidget.shadowRoot;

//     var widgetRoot = shadowRoot.querySelector(
//       '.rc-widget__root'
//     );

//     if (!widgetRoot) {

//       if (attempt < maxAttempts) {
//         setTimeout(initRechargeWidget, 200);
//       }

//       return;
//     }


//     /*
//      * ---------------------------------------------------------
//      * 1. ARIA LABELS
//      * ---------------------------------------------------------
//      */

//     widgetRoot
//       .querySelectorAll('.rc-purchase-option__input')
//       .forEach(function (radio) {

//         if (radio.dataset.ariaApplied) {
//           return;
//         }

//         if (radio.value === 'onetime') {

//           radio.setAttribute(
//             'aria-label',
//             'onetime-purchase-select'
//           );

//         } else if (radio.value === 'subscription') {

//           radio.setAttribute(
//             'aria-label',
//             'subscription-purchase-select'
//           );
//         }

//         radio.dataset.ariaApplied = 'true';
//       });


//     /*
//      * ---------------------------------------------------------
//      * 2. FIND PURCHASE OPTIONS
//      * ---------------------------------------------------------
//      */

//     var subscriptionOption = widgetRoot.querySelector(
//       '.rc-purchase-option__subscription'
//     );

//     var oneTimeOption = widgetRoot.querySelector(
//       '.rc-selection__onetime'
//     );

//     if (!subscriptionOption || !oneTimeOption) {

//       if (attempt < maxAttempts) {
//         setTimeout(initRechargeWidget, 200);
//       }

//       return;
//     }


//     /*
//      * ---------------------------------------------------------
//      * 3. GET ONE-TIME PRICE
//      * ---------------------------------------------------------
//      */

//     var oneTimePriceElement = oneTimeOption.querySelector(
//       '.rc-purchase-option__selector'
//     );

//     var oneTimePrice = '';

//     if (oneTimeOption.querySelector('.rc-price')) {

//       oneTimePrice =
//         oneTimeOption
//           .querySelector('.rc-price')
//           .textContent
//           .trim();

//     } else {

//       /*
//        * Fallback based on current Recharge markup
//        */
//       var oneTimePriceNode = oneTimeOption.querySelector(
//         '.rc-purchase-option__prices'
//       );

//       if (oneTimePriceNode) {

//         oneTimePrice =
//           oneTimePriceNode.textContent.trim();
//       }
//     }


//     /*
//      * ---------------------------------------------------------
//      * 4. SPLIT PRICE
//      * ---------------------------------------------------------
//      */

//     var splitedPrice = oneTimePrice.split('$');

//     var finalPrice = splitedPrice.pop() || '';

//     var oneTimeLabel =
//       splitedPrice.join('$').trim();


//     /*
//      * ---------------------------------------------------------
//      * 5. ORIGINAL PDP PRICE
//      * ---------------------------------------------------------
//      */

//     var originalPrice =
//       $('.product__info-wrapper .price__container .price__sale s.price-item--regular')
//         .text()
//         .trim();

//     var cleanedPrice =
//       originalPrice.replace(/[^0-9.]/g, '');

//     var formattedPrice = '';

//     if (cleanedPrice) {

//       var parsedOriginalPrice =
//         parseFloat(cleanedPrice);

//       if (!isNaN(parsedOriginalPrice)) {

//         formattedPrice =
//           '$' + parsedOriginalPrice.toFixed(2);
//       }
//     }


//     /*
//      * ---------------------------------------------------------
//      * 6. OFFER PRICE
//      * ---------------------------------------------------------
//      */

//     var offerBlock =
//       $('.price-section .offer-price-block');

//     var hasOffer =
//       offerBlock.length > 0;


//     var combinedContent = '';
//     var finalPriceHTML = '';


//     if (hasOffer) {

//       var offerPercentage =
//         $('.offer-price-block .offer-percentage')
//           .text()
//           .trim();

//       splitedPrice =
//         oneTimeLabel +
//         ': <b>SAVE ' +
//         offerPercentage +
//         '%</b>';


//       var offerOriginalPrice =
//         $('.offer-price-block .original-price-item')
//           .text()
//           .trim();

//       var originalPriceValue =
//         offerOriginalPrice.replace(/[^0-9.]/g, '');

//       var originalOneTimePrice = '';

//       if (originalPriceValue) {

//         var parsedOfferOriginal =
//           parseFloat(originalPriceValue);

//         if (!isNaN(parsedOfferOriginal)) {

//           originalOneTimePrice =
//             '$' + parsedOfferOriginal.toFixed(2);
//         }
//       }


//       var offerPrice =
//         $('.offer-price-block .offer-price-item')
//           .text()
//           .trim();


//       finalPriceHTML =
//         '<s>' +
//         originalOneTimePrice +
//         '</s>' +
//         '<span class="offer-price">' +
//         offerPrice +
//         '</span>';


//       combinedContent =
//         'One-Time Purchase ' +
//         splitedPrice;


//     } else {

//       finalPriceHTML =
//         '$' +
//         finalPrice;

//       combinedContent =
//         'One-Time Purchase ' +
//         oneTimeLabel;
//     }


//     /*
//      * ---------------------------------------------------------
//      * 7. SUBSCRIPTION PRICE
//      * ---------------------------------------------------------
//      *
//      * New Recharge structure:
//      *
//      * .rc-purchase-option__prices
//      *     .rc-price.strike-through
//      *     .rc-price
//      */

//     var subscriptionPriceContainer =
//       subscriptionOption.querySelector(
//         '.rc-purchase-option__prices'
//       );

//     var subscriptionDiscountedPrice = '';

//     if (subscriptionPriceContainer) {

//       var priceElements =
//         subscriptionPriceContainer.querySelectorAll(
//           '.rc-price'
//         );

//       /*
//        * Last .rc-price = discounted price
//        */
//       if (priceElements.length) {

//         subscriptionDiscountedPrice =
//           priceElements[
//             priceElements.length - 1
//           ].textContent.trim();
//       }
//     }


//     /*
//      * ---------------------------------------------------------
//      * 8. UPDATE STICKY FOOTER
//      * ---------------------------------------------------------
//      */

//     var stickyStrikePrice = '';

//     if (originalPrice) {

//       stickyStrikePrice =
//         '<s>' +
//         formattedPrice +
//         '</s>';
//     }

//     $('.pdp-sticky-footer .sticky-footer-price')
//       .html(
//         stickyStrikePrice +
//         subscriptionDiscountedPrice
//       );




//     /*
//      * ---------------------------------------------------------
//      * 10. ONE-TIME PRICE
//      * ---------------------------------------------------------
//      */

//     var oneTimePriceContainer =
//       oneTimeOption.querySelector(
//         '.rc-purchase-option__prices'
//       );

//     if (oneTimePriceContainer) {

//       var existingCustomPrice =
//         oneTimePriceContainer.querySelector(
//           '.custom-onetime-price'
//         );

//       if (!existingCustomPrice) {

//         var customPrice =
//           document.createElement('span');

//         customPrice.className =
//           'custom-onetime-price';

//         customPrice.innerHTML =
//           finalPriceHTML;

//         oneTimePriceContainer.innerHTML = '';

//         oneTimePriceContainer.appendChild(
//           customPrice
//         );
//       }
//     }

//     /*
//      * ---------------------------------------------------------
//      * 12. WKND 10% OFFER
//      * ---------------------------------------------------------
//      */

//     if (
//       oneTimeOption.classList.contains('wkndten')
//     ) {

//       if (
//         !oneTimeOption.querySelector(
//           '.get-offer'
//         )
//       ) {

//         var offerText =
//           document.createElement('p');

//         offerText.className =
//           'get-offer';

//         offerText.textContent =
//           'Get 10% off at checkout today';

//         oneTimeOption.appendChild(
//           offerText
//         );
//       }
//     }


//     /*
//      * ---------------------------------------------------------
//      * 13. SELLING PLANS
//      * ---------------------------------------------------------
//      */

//     var sellingPlans =
//       widgetRoot.querySelector(
//         'rc-selling-plans'
//       );

//     if (sellingPlans) {

//       /*
//        * Recharge selling plans has its OWN shadow root.
//        */
//       var sellingPlansShadow =
//         sellingPlans.shadowRoot;

//       if (sellingPlansShadow) {

//         var plansContainer =
//           sellingPlansShadow.querySelector(
//             '.rc-plans-button-group'
//           );

//         if (plansContainer) {

//           plansContainer.classList.add(
//             'customized-selling-plans'
//           );
//         }
//       }
//     }


//     /*
//      * ---------------------------------------------------------
//      * 14. SAVE AND SUBSCRIBE CONTENT
//      * ---------------------------------------------------------
//      *
//      * If .save-and-subscribe-pdp is outside Recharge,
//      * it must NOT be searched through widgetRoot.
//      */

// // Recharge widget is inside Shadow DOM
// var rechargeWidget = document.querySelector(
//     'recharge-subscription-widget'
// );

// if (!rechargeWidget || !rechargeWidget.shadowRoot) {
//     return;
// }

// var widgetRoot = rechargeWidget.shadowRoot.querySelector(
//     '.rc-widget__root'
// );

// if (!widgetRoot) {
//     return;
// }


// // Subscription option inside Recharge Shadow DOM
// var subscriptionOption = widgetRoot.querySelector(
//     '.rc-purchase-option__subscription'
// );


// // save-and-subscribe-pdp is OUTSIDE Recharge Shadow DOM
// var saveSubscribe = document.querySelector(
//     '.save-and-subscribe-pdp'
// );

// if (saveSubscribe) {
//     saveSubscribe.style.display = 'flex';
// }


//     /*
//      * ---------------------------------------------------------
//      * 15. PRICE BLOCK FOR NON-WIDGET CUSTOM UI
//      * ---------------------------------------------------------
//      */

//     if (
//       $('.recharge-subscription-widget').length &&
//       !$('.recharge-subscription-widget .rc-widget').length
//     ) {

//       function formattedPriceFinal(
//         selector,
//         prefix
//       ) {

//         var priceText =
//           $(selector).text();

//         var priceValue =
//           parseFloat(
//             priceText.replace(
//               /[^0-9.]/g,
//               ''
//             )
//           );

//         if (isNaN(priceValue)) {
//           return '';
//         }

//         return (
//           prefix +
//           priceValue.toFixed(2)
//         );
//       }


//       var offOneTimePriceFinal =
//         formattedPriceFinal(
//           '.offer-price-block .offer-price-item',
//           '$'
//         );


//       var offOneTimePriceSticky =
//         formattedPriceFinal(
//           '.offer-price-block s.original-price-item',
//           '$'
//         );


//       var customFormattedPrice =
//         formattedPriceFinal(
//           '.product__info-wrapper .price-section .price__container .price__sale .price-item',
//           '$'
//         );


//       if (hasOffer) {

//         $('.custom-onetime-radio .price-label')
//           .html(
//             '<s>' +
//             offOneTimePriceSticky +
//             '</s>' +
//             offOneTimePriceFinal
//           );


//         $('.pdp-sticky-footer .sticky-footer-price')
//           .html(
//             '<s>' +
//             offOneTimePriceSticky +
//             '</s>' +
//             offOneTimePriceFinal
//           );

//       } else {

//         var regularPrice =
//           $('.product__info-wrapper .price__container .price-section s.price-item--regular')
//             .text()
//             .trim();


//         $('.custom-onetime-radio .price-label')
//           .html(
//             '<s>' +
//             regularPrice +
//             '</s>' +
//             customFormattedPrice
//           );


//         $('.pdp-sticky-footer .sticky-footer-price')
//           .html(
//             '<s>' +
//             regularPrice +
//             '</s>' +
//             customFormattedPrice
//           );
//       }
//     }


//     /*
//      * ---------------------------------------------------------
//      * 16. MARK WIDGET AS READY
//      * ---------------------------------------------------------
//      */

//     widgetRoot.classList.add(
//       'rc-widget-customized'
//     );

//   }


//   /*
//    * Start initialization
//    */
//   setTimeout(
//     initRechargeWidget,
//     250
//   );
// }

function rcWidjectCustomize(skipIfLoggedIn = true) {

  if (skipIfLoggedIn && window.SESSION_CUSTOMER_CACHE_KEY) {
    return;
  }

  var maxAttempts = 50;
  var attempt = 0;

  function initRechargeWidget() {

    attempt++;

    var rechargeWidget = document.querySelector(
      'recharge-subscription-widget'
    );

    if (
      !rechargeWidget ||
      !rechargeWidget.shadowRoot
    ) {
      if (attempt < maxAttempts) {
        setTimeout(initRechargeWidget, 200);
      }
      return;
    }

    var shadowRoot = rechargeWidget.shadowRoot;

    var widgetRoot = shadowRoot.querySelector(
      '.rc-widget__root'
    );

    if (!widgetRoot) {
      if (attempt < maxAttempts) {
        setTimeout(initRechargeWidget, 200);
      }
      return;
    }


    /*
     * ---------------------------------------------------------
     * SUBSCRIPTION OPTION
     * ---------------------------------------------------------
     */

    var subscriptionOption =
      widgetRoot.querySelector(
        '.rc-purchase-option__subscription'
      );

    if (!subscriptionOption) {
      if (attempt < maxAttempts) {
        setTimeout(initRechargeWidget, 200);
      }
      return;
    }



    /*
     * ---------------------------------------------------------
     * ARIA LABELS
     * ---------------------------------------------------------
     */

    widgetRoot
      .querySelectorAll(
        '.rc-purchase-option__input'
      )
      .forEach(function (radio) {

        if (radio.dataset.ariaApplied) {
          return;
        }

        if (radio.value === 'onetime') {

          radio.setAttribute(
            'aria-label',
            'onetime-purchase-select'
          );

        } else if (
          radio.value === 'subscription'
        ) {

          radio.setAttribute(
            'aria-label',
            'subscription-purchase-select'
          );
        }

        radio.dataset.ariaApplied = 'true';

      });


    /*
     * ---------------------------------------------------------
     * ONE-TIME PURCHASE
     * ---------------------------------------------------------
     */

    var oneTimeOption =
      widgetRoot.querySelector(
        '.rc-selection__onetime'
      );


    /*
     * ---------------------------------------------------------
     * ONE-TIME PRICE
     * ---------------------------------------------------------
     */

    var oneTimePrice = '';

    if (oneTimeOption) {

      var oneTimePriceElement =
        oneTimeOption.querySelector(
          '.rc-price'
        );

      if (oneTimePriceElement) {

        oneTimePrice =
          oneTimePriceElement.textContent.trim();

      }
    }


    /*
     * ---------------------------------------------------------
     * ORIGINAL PDP PRICE
     * ---------------------------------------------------------
     */

    var originalPrice =
      $('.product__info-wrapper .price__container .price__sale s.price-item--regular')
        .text()
        .trim();

    var cleanedPrice =
      originalPrice.replace(
        /[^0-9.]/g,
        ''
      );

    var formattedPrice = '';

    if (cleanedPrice) {

      var parsedOriginalPrice =
        parseFloat(cleanedPrice);

      if (!isNaN(parsedOriginalPrice)) {

        formattedPrice =
          '$' +
          parsedOriginalPrice.toFixed(2);
      }
    }


    /*
     * ---------------------------------------------------------
     * SUBSCRIPTION PRICE
     * ---------------------------------------------------------
     */

    var subscriptionPrice = '';

    var subscriptionPrices =
      subscriptionOption.querySelector(
        '.rc-purchase-option__prices'
      );

    if (subscriptionPrices) {

      var priceElements =
        subscriptionPrices.querySelectorAll(
          '.rc-price'
        );

      if (priceElements.length) {

        subscriptionPrice =
          priceElements[
            priceElements.length - 1
          ].textContent.trim();
      }
    }


    /*
     * ---------------------------------------------------------
     * STICKY FOOTER
     * ---------------------------------------------------------
     */

    var stickyStrikePrice = '';

    if (originalPrice) {

      stickyStrikePrice =
        '<s>' +
        formattedPrice +
        '</s>';
    }

    $('.pdp-sticky-footer .sticky-footer-price')
      .html(
        stickyStrikePrice +
        subscriptionPrice
      );


    /*
     * ---------------------------------------------------------
     * READY
     * ---------------------------------------------------------
     */

    widgetRoot.classList.add(
      'rc-widget-customized'
    );

  }


  setTimeout(
    initRechargeWidget,
    250
  );
}


/*
 * ---------------------------------------------------------
 * RECHARGE SAVE & SUBSCRIBE
 * ---------------------------------------------------------
 *
 * Required structure inside Recharge:
 *
 * .rc-purchase-option__subscription
 *   ├── .save-and-subscribe-pdp
 *   └── .custom-save-and-subscribe
 *
 * Recharge can recreate the subscription DOM when switching
 * between One-time Purchase and Subscription.
 *
 * Therefore we keep a source copy and recreate both elements
 * whenever Recharge renders the subscription option again.
 * ---------------------------------------------------------
 */


/*
 * ---------------------------------------------------------
 * RECHARGE SAVE & SUBSCRIBE
 * ---------------------------------------------------------
 */

(function () {

  var saveSubscribeTemplate = null;
  var observer = null;
  var syncing = false;


  /*
   * Get the original Save & Subscribe element.
   *
   * We keep a detached template so Recharge can remove/rebuild
   * its subscription DOM without losing our source element.
   */
  function getTemplate() {

    if (saveSubscribeTemplate) {
      return saveSubscribeTemplate;
    }

    var original = document.querySelector(
      '.save-and-subscribe-pdp:not(.recharge-save-and-subscribe-original)'
    );

    if (!original) {
      return null;
    }

    saveSubscribeTemplate = original.cloneNode(true);

    return saveSubscribeTemplate;
  }


  /*
   * Add Save & Subscribe to the CURRENT Recharge subscription.
   */
  function syncSaveSubscribe() {

    if (syncing) {
      return;
    }

    var rechargeWidget = document.querySelector(
      'recharge-subscription-widget'
    );

    if (
      !rechargeWidget ||
      !rechargeWidget.shadowRoot
    ) {
      return;
    }

    var widgetRoot = rechargeWidget.shadowRoot.querySelector(
      '.rc-widget__root'
    );

    if (!widgetRoot) {
      return;
    }


    /*
     * Only work with the currently rendered subscription option.
     */
    var subscriptionOption = widgetRoot.querySelector(
      '.rc-purchase-option__subscription'
    );

    if (!subscriptionOption) {
      return;
    }


    /*
     * Get our permanent template.
     */
    var template = getTemplate();

    if (!template) {
      return;
    }


    /*
     * Recharge's subscription container.
     */
    var subContainer = subscriptionOption.querySelector(
      '.rc-purchase-option__sub-container'
    );

    var target = subContainer || subscriptionOption;


    /*
     * ---------------------------------------------------------
     * REMOVE DUPLICATES
     * ---------------------------------------------------------
     *
     * If Recharge/custom code has already inserted more than
     * one copy, keep ONLY the first one.
     */
var saveSubscribeElements =
    target.querySelectorAll('.save-and-subscribe-pdp');

if (saveSubscribeElements.length > 1) {
    for (var i = 1; i < saveSubscribeElements.length; i++) {
        saveSubscribeElements[i].remove();
    }
}


    /*
     * ---------------------------------------------------------
     * ADD ONLY ONE COPY
     * ---------------------------------------------------------
     */
    var existing = target.querySelector(
      '.save-and-subscribe-pdp'
    );

    if (!existing) {

      syncing = true;

      var clone = template.cloneNode(true);

      clone.classList.add(
        'recharge-save-and-subscribe-original'
      );

      clone.style.display = 'flex';

      target.appendChild(clone);

      syncing = false;

      existing = clone;
    }


    /*
     * Always make it visible.
     */
    if (existing) {
      existing.style.display = 'flex';
    }


    /*
     * ---------------------------------------------------------
     * CUSTOM SAVE & SUBSCRIBE
     * ---------------------------------------------------------
     *
     * Add this only if you actually need the
     * .custom-save-and-subscribe element.
     */
    var customSaveSubscribe = target.querySelector(
      '.custom-save-and-subscribe'
    );

    if (
      !customSaveSubscribe &&
      template.querySelector('.see-details-offer-text')
    ) {

      syncing = true;

      var customWrapper =
        document.createElement('div');

      customWrapper.className =
        'custom-save-and-subscribe';


      var learnMore =
        template.querySelector(
          '.see-details-offer-text'
        );


      if (learnMore) {

        var clonedLearnMore =
          learnMore.cloneNode(true);

        clonedLearnMore.removeAttribute(
          'data-toggle'
        );

        clonedLearnMore.removeAttribute(
          'data-target'
        );


        clonedLearnMore.addEventListener(
          'click',
          function (event) {

            event.preventDefault();
            event.stopPropagation();

            var modal =
              document.querySelector(
                '#see-details-modal'
              );

            if (!modal) {
              return;
            }


            /*
             * Bootstrap 4
             */
            if (
              typeof window.jQuery !== 'undefined' &&
              typeof window.jQuery.fn.modal === 'function'
            ) {

              window.jQuery(modal).modal('show');

              return;
            }


            /*
             * Bootstrap 5
             */
            if (
              typeof window.bootstrap !== 'undefined' &&
              window.bootstrap.Modal
            ) {

              window.bootstrap.Modal
                .getOrCreateInstance(modal)
                .show();

              return;
            }


            /*
             * Fallback
             */
            modal.classList.add('show');

            modal.style.display = 'block';

            modal.removeAttribute(
              'aria-hidden'
            );

            modal.setAttribute(
              'aria-modal',
              'true'
            );
          }
        );


        customWrapper.appendChild(
          clonedLearnMore
        );

        target.appendChild(
          customWrapper
        );
      }

      syncing = false;
    }
  }


  /*
   * ---------------------------------------------------------
   * OBSERVE RECHARGE DOM
   * ---------------------------------------------------------
   */
  function initObserver() {

    var rechargeWidget = document.querySelector(
      'recharge-subscription-widget'
    );

    if (
      !rechargeWidget ||
      !rechargeWidget.shadowRoot
    ) {
      setTimeout(
        initObserver,
        200
      );

      return;
    }


    var widgetRoot =
      rechargeWidget.shadowRoot.querySelector(
        '.rc-widget__root'
      );

    if (!widgetRoot) {

      setTimeout(
        initObserver,
        200
      );

      return;
    }


    /*
     * Initial sync.
     */
    syncSaveSubscribe();


    /*
     * Disconnect previous observer.
     */
    if (observer) {
      observer.disconnect();
    }


    observer = new MutationObserver(
      function () {

        if (syncing) {
          return;
        }


        /*
         * Wait until Recharge finishes its DOM update.
         */
        clearTimeout(
          observer._timer
        );


        observer._timer = setTimeout(
          function () {

            syncSaveSubscribe();

          },
          100
        );
      }
    );


    observer.observe(
      widgetRoot,
      {
        childList: true,
        subtree: true
      }
    );
  }


  /*
   * ---------------------------------------------------------
   * START
   * ---------------------------------------------------------
   */
  function start() {

    /*
     * Get template before moving/manipulating it.
     */
    getTemplate();

    initObserver();
  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      start
    );

  } else {

    start();

  }

})();






/*
 * =========================================================
 * RECHARGE SAVE & SUBSCRIBE
 * =========================================================
 *
 * Expected:
 *
 * Subscription selected:
 *   .save-and-subscribe-pdp       -> visible
 *   .custom-save-and-subscribe    -> visible
 *
 * One-time selected:
 *   .save-and-subscribe-pdp       -> hidden
 *   .custom-save-and-subscribe    -> hidden
 *
 * Also prevents duplicate elements when Recharge
 * rebuilds the subscription DOM.
 * =========================================================
 */

(function () {

  var saveSubscribeTemplate = null;
  var rechargeObserver = null;
  var syncTimer = null;
  var isSyncing = false;


  /*
   * ---------------------------------------------------------
   * GET ORIGINAL SAVE & SUBSCRIBE TEMPLATE
   * ---------------------------------------------------------
   */
  function getSaveSubscribeTemplate() {

    if (saveSubscribeTemplate) {
      return saveSubscribeTemplate;
    }

    var original = document.querySelector(
      '.save-and-subscribe-pdp:not(.recharge-save-and-subscribe-original)'
    );

    if (!original) {
      return null;
    }

    /*
     * Store detached copy.
     */
    saveSubscribeTemplate =
      original.cloneNode(true);

    /*
     * Original element should not remain visible
     * outside Recharge.
     */
    original.style.display = 'none';

    return saveSubscribeTemplate;
  }


  /*
   * ---------------------------------------------------------
   * CHECK WHETHER SUBSCRIPTION IS SELECTED
   * ---------------------------------------------------------
   */
  function isSubscriptionSelected(subscriptionOption) {

    if (!subscriptionOption) {
      return false;
    }

    /*
     * Recharge selected class.
     */
    if (
      subscriptionOption.classList.contains(
        'rc-purchase-option__selected'
      )
    ) {
      return true;
    }

    /*
     * Recharge selected attribute.
     */
    if (
      subscriptionOption.hasAttribute(
        'rc-selected'
      )
    ) {
      return true;
    }

    /*
     * Radio checked state.
     */
    var radio =
      subscriptionOption.querySelector(
        'input[type="radio"][value="subscription"]'
      );

    if (
      radio &&
      radio.checked
    ) {
      return true;
    }

    return false;
  }


  /*
   * ---------------------------------------------------------
   * REMOVE DUPLICATES
   * ---------------------------------------------------------
   */
  function removeDuplicateElements(target) {

    /*
     * .save-and-subscribe-pdp
     */
    var saveElements =
      target.querySelectorAll(
        '.save-and-subscribe-pdp'
      );

    /*
     * Keep only ONE.
     */
    for (
      var i = 1;
      i < saveElements.length;
      i++
    ) {
      saveElements[i].remove();
    }


    /*
     * .custom-save-and-subscribe
     */
    var customElements =
      target.querySelectorAll(
        '.custom-save-and-subscribe'
      );

    /*
     * Keep only ONE.
     */
    for (
      var j = 1;
      j < customElements.length;
      j++
    ) {
      customElements[j].remove();
    }
  }


  /*
   * ---------------------------------------------------------
   * CREATE CUSTOM SAVE & SUBSCRIBE
   * ---------------------------------------------------------
   */
  function createCustomSaveSubscribe(template) {

    if (!template) {
      return null;
    }

    var learnMore =
      template.querySelector(
        '.see-details-offer-text'
      );

    if (!learnMore) {
      return null;
    }

    var wrapper =
      document.createElement('div');

    wrapper.className =
      'custom-save-and-subscribe';


    var clonedLearnMore =
      learnMore.cloneNode(true);


    /*
     * Remove Bootstrap attributes.
     */
    clonedLearnMore.removeAttribute(
      'data-toggle'
    );

    clonedLearnMore.removeAttribute(
      'data-target'
    );


    /*
     * Learn More click.
     */
    clonedLearnMore.addEventListener(
      'click',
      function (event) {

        event.preventDefault();
        event.stopPropagation();


        var modal =
          document.querySelector(
            '#see-details-modal'
          );


        if (!modal) {
          return;
        }


        /*
         * Bootstrap 4
         */
        if (
          typeof window.jQuery !== 'undefined' &&
          typeof window.jQuery.fn.modal === 'function'
        ) {

          window.jQuery(modal).modal(
            'show'
          );

          return;
        }


        /*
         * Bootstrap 5
         */
        if (
          typeof window.bootstrap !== 'undefined' &&
          window.bootstrap.Modal
        ) {

          window.bootstrap.Modal
            .getOrCreateInstance(modal)
            .show();

          return;
        }


        /*
         * Fallback.
         */
        modal.classList.add('show');

        modal.style.display =
          'block';

        modal.removeAttribute(
          'aria-hidden'
        );

        modal.setAttribute(
          'aria-modal',
          'true'
        );
      }
    );


    wrapper.appendChild(
      clonedLearnMore
    );


    return wrapper;
  }


  /*
   * ---------------------------------------------------------
   * SYNC SAVE & SUBSCRIBE
   * ---------------------------------------------------------
   */
  function syncSaveSubscribe() {

    if (isSyncing) {
      return;
    }


    var rechargeWidget =
      document.querySelector(
        'recharge-subscription-widget'
      );


    if (
      !rechargeWidget ||
      !rechargeWidget.shadowRoot
    ) {
      return;
    }


    var widgetRoot =
      rechargeWidget.shadowRoot.querySelector(
        '.rc-widget__root'
      );


    if (!widgetRoot) {
      return;
    }


    /*
     * Get CURRENT subscription option.
     */
    var subscriptionOption =
      widgetRoot.querySelector(
        '.rc-purchase-option__subscription'
      );


    if (!subscriptionOption) {
      return;
    }


    /*
     * Check selected state.
     */
    var subscriptionSelected =
      isSubscriptionSelected(
        subscriptionOption
      );


    /*
     * Recharge subscription container.
     */
    var subContainer =
      subscriptionOption.querySelector(
        '.rc-purchase-option__sub-container'
      );


    var target =
      subContainer ||
      subscriptionOption;


    /*
     * -------------------------------------------------------
     * ALWAYS REMOVE DUPLICATES FIRST
     * -------------------------------------------------------
     */
    removeDuplicateElements(
      target
    );


    /*
     * -------------------------------------------------------
     * ONE-TIME PURCHASE SELECTED
     * -------------------------------------------------------
     *
     * Recharge can keep the subscription DOM in place,
     * so explicitly hide our elements.
     */
    if (!subscriptionSelected) {

      target
        .querySelectorAll(
          '.save-and-subscribe-pdp, .custom-save-and-subscribe'
        )
        .forEach(
          function (element) {

            element.style.display =
              'none';

          }
        );

      return;
    }


    /*
     * -------------------------------------------------------
     * SUBSCRIPTION SELECTED
     * -------------------------------------------------------
     */
    var template =
      getSaveSubscribeTemplate();


    if (!template) {
      return;
    }


    isSyncing = true;


    /*
     * -------------------------------------------------------
     * .save-and-subscribe-pdp
     * -------------------------------------------------------
     */
    var saveSubscribe =
      target.querySelector(
        '.save-and-subscribe-pdp'
      );


    if (!saveSubscribe) {

      saveSubscribe =
        template.cloneNode(true);

      saveSubscribe.classList.add(
        'recharge-save-and-subscribe-original'
      );

      target.appendChild(
        saveSubscribe
      );
    }


    saveSubscribe.style.display =
      'flex';


    /*
     * -------------------------------------------------------
     * .custom-save-and-subscribe
     * -------------------------------------------------------
     */
    var customSaveSubscribe =
      target.querySelector(
        '.custom-save-and-subscribe'
      );


    if (!customSaveSubscribe) {

      customSaveSubscribe =
        createCustomSaveSubscribe(
          template
        );


      if (customSaveSubscribe) {

        target.appendChild(
          customSaveSubscribe
        );

      }
    }


    if (customSaveSubscribe) {

      customSaveSubscribe.style.display =
        'flex';

    }


    isSyncing = false;
  }


  /*
   * ---------------------------------------------------------
   * DEBOUNCE
   * ---------------------------------------------------------
   */
  function scheduleSync() {

    if (isSyncing) {
      return;
    }


    clearTimeout(
      syncTimer
    );


    syncTimer =
      setTimeout(
        function () {

          syncSaveSubscribe();

        },
        100
      );
  }


  /*
   * ---------------------------------------------------------
   * OBSERVE RECHARGE
   * ---------------------------------------------------------
   */
  function initRechargeObserver() {

    var rechargeWidget =
      document.querySelector(
        'recharge-subscription-widget'
      );


    if (
      !rechargeWidget ||
      !rechargeWidget.shadowRoot
    ) {

      setTimeout(
        initRechargeObserver,
        200
      );

      return;
    }


    var widgetRoot =
      rechargeWidget.shadowRoot.querySelector(
        '.rc-widget__root'
      );


    if (!widgetRoot) {

      setTimeout(
        initRechargeObserver,
        200
      );

      return;
    }


    /*
     * Initial load.
     */
    scheduleSync();


    /*
     * Prevent duplicate observers.
     */
    if (rechargeObserver) {
      rechargeObserver.disconnect();
    }


    rechargeObserver =
      new MutationObserver(
        function () {

          if (isSyncing) {
            return;
          }

          scheduleSync();

        }
      );


    rechargeObserver.observe(
      widgetRoot,
      {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: [
          'class',
          'rc-selected'
        ]
      }
    );
  }


  /*
   * ---------------------------------------------------------
   * START
   * ---------------------------------------------------------
   */
  function startSaveSubscribe() {

    /*
     * Capture original element before Recharge changes it.
     */
    getSaveSubscribeTemplate();

    /*
     * Start observing Recharge.
     */
    initRechargeObserver();
  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      startSaveSubscribe
    );

  } else {

    startSaveSubscribe();

  }

})();






$(document).on('click', function(){
  oneTimewknd();
});

$(document).on('click','.quick-add__submit', function(){
  var productID = $(this).attr("data-productid");
  setTimeout(function(){
    rcWidjectCustomize();
    pdpReadMore();
    if(productID && $('.rc-widget__root').length == 0){
      window.ReChargeWidget.createWidget({ productId: productID, injectionParent: '.recharge-subscription-widget' });
    }
   },2000);
   setTimeout(function(){
     if($('.rc-widget__root').length > 0){
      $('.quick-add-modal__content-info').css('visibility','visible');
      const $saveAndSubscribe = $('.save-and-subscribe-pdp');
      $saveAndSubscribe.insertAfter('.quick-add-modal .rc-subscription-details');
      $('.quick-add-modal .product__media-list .product__media-item:nth-child(1) .product__media img').trigger('click');
      $saveAndSubscribe.insertAfter('.quick-add-modal .rc-purchase-option__subscription .rc-purchase-option__selector');
      $saveAndSubscribe.show();
      $('.shipping-frequency-section').insertAfter('.quick-add-modal .rc-purchase-option__subscription .rc-purchase-option__selector');
   }
   },5000);
});

// $(document).on('click', '.rc-purchase-option__subscription, .rc-selection__onetime', function () {
//     setTimeout(function () {
//      if ($('.rc-purchase-option__subscription .shipping-frequency-section').length == 0) {
//         var clonedSection = $('.shipping-frequency-section').clone();
//         $('.rc-selling-plans rc-selling-plans, .rc-selling-plans .rc-selling-plans-dropdown .rc-selling-plans-dropdown__select').after(clonedSection);
//      }
//     }, 500);
//        if (
//         $this.hasClass('rc-purchase-option__onetime') &&
//         $this.hasClass('rc-purchase-option__selected')
//       ){
//     $('.product-form__quantity').show();
//   } else {
//     $('.product-form__quantity').hide();
//   }
//     });

$(document).on('click', 'recharge-subscription-widget', function (e) {
    var widget = this;
    var shadowRoot = widget.shadowRoot;
    if (!shadowRoot) {
        console.log('Shadow root NOT found');
        return;
    }
    setTimeout(function () {
        // Get the One-time purchase option inside Shadow DOM
        var onetimeOption = shadowRoot.querySelector(
            '.rc-selection__onetime'
        );

        // Get subscription option inside Shadow DOM
        var subscriptionOption = shadowRoot.querySelector(
            '.rc-purchase-option__subscription'
        );
        if (
            subscriptionOption &&
            subscriptionOption.querySelector(
                '.shipping-frequency-section'
            ) === null
        ) {

            // Get the existing shipping frequency section
            var shippingFrequencySection =
                document.querySelector(
                    '.shipping-frequency-section'
                );

            if (shippingFrequencySection) {

                var clonedSection =
                    shippingFrequencySection.cloneNode(true);


                var sellingPlans =
                    shadowRoot.querySelector(
                        '.rc-selling-plans rc-selling-plans'
                    );

                var sellingPlansDropdown =
                    shadowRoot.querySelector(
                        '.rc-selling-plans .rc-selling-plans-dropdown .rc-selling-plans-dropdown__select'
                    );

                if (sellingPlansDropdown) {

                    sellingPlansDropdown.after(
                        clonedSection
                    );

                } else if (sellingPlans) {

                    sellingPlans.after(
                        clonedSection
                    );

                } else {

                }
            } else {

            }
        }

        if (
            onetimeOption &&
            onetimeOption.hasAttribute('rc-selected')
        ) {

            $('.product-form__quantity').addClass('show');

        } else {

            $('.product-form__quantity').removeClass('show');
        }

    }, 200);

});



$(document).on('click','.shipping-frequency-section label', function(){
    $('.shipping-frequency-section .paymentOpTooltip').toggleClass('active');
});

//play video button
 $('.tech-video-btn').click(function (){
    $('.video-player-modal').addClass('visible');
    $('body').addClass('no-scroll');
    $('html').css("overflow-y", "hidden");
    var dataVideoURL = $(this).attr('data-videourl');
    $('video#'+dataVideoURL).trigger('load').trigger('play');
});

 $('.tech-video-button').click(function (){
    $('.video-player-modal').addClass('visible');
    $('body').addClass('no-scroll');
    $('html').css("overflow-y", "hidden");
    var dataVideoURL = $(this).attr('data-videourl');
    $('#lp-technology-video').trigger('load').trigger('play');
});

// $(document).ready(function(){
//  setTimeout(function(){
//    oneTimewknd();
//  },1000);
//   setInterval(function(){
//     $("#block-text-content-section_text_block_6tmdLg").toggleClass("highlight")
//   },1000);
//   setTimeout(function () {
//     if ($('.recharge-subscription-widget .rc-widget__root').length === 0) {
//       $('.custom-rc-widget').attr('style', 'display:block !important;');
//       $(".custom-rc-widget.custom-rc-widget-hidden").css("opacity","1");
//     }
//   }, 4500);
// })

$(document).ready(function () {

  setTimeout(function () {
    oneTimewknd();
  }, 1000);

  setInterval(function () {
    $("#block-text-content-section_text_block_6tmdLg").toggleClass("highlight");
  }, 1000);

  setTimeout(function () {

    const rechargeWidget = document.querySelector(
      '.recharge-subscription-widget recharge-subscription-widget'
    );

    const rechargeLoaded =
      rechargeWidget &&
      rechargeWidget.shadowRoot &&
      rechargeWidget.shadowRoot.querySelector('.rc-widget__root');

    if (!rechargeLoaded) {

      $('.custom-rc-widget')
        .removeClass('custom-rc-widget-hidden')
        .css({
          display: 'block',
          opacity: '1'
        });

    }

  }, 4500);

});
$(document).ready(function(){
  pdpReadMore();
  rcWidjectCustomize();
    $(".pdp-page , .pdp-product-section").on('click', function(e) {
      if (!$(e.target).is('.shipping-frequency-section label')) {
        $('.shipping-frequency-section .paymentOpTooltip').removeClass('active');
      }
    });

    //pdp-sticky footer button click
    $('.pdp-sticky-footer .btn-checkout#stickyFooterAddToCart').on("click", function(){
      $('.buy-button .addto-cart-button').trigger('click');
   });

   $('.pdp-sticky-footer .btn-checkout#stickyFooterAddToKit').on("click", function(){
    $('.buy-button #addToKitPdp').trigger('click');
   });

  $('.pdp-sticky-footer .btn-checkout-wrapper').on("click", function(){
    $("html, body").animate({ scrollTop: $(".addto-cart-button").offset().top - 100});
  });

  if($('#lp-technology-video').length>0) {
    var ellenReply = document.getElementById("lp-technology-video");
	var replay = document.getElementById("replayButton");
	$(replay).click(function (){
	$(".replayButton").addClass("hide");
	$(ellenReply).trigger('load').trigger('play');
	});
	function videoEnd() {
		replay.className = "replayButton";
		ellenReply.setAttribute("controls","controls");
		$(".replayButton").show();
	}
	ellenReply.addEventListener("ended", videoEnd, false);
	ellenReply.addEventListener('pause', function () {
		ellenReply.pause();
	}, false);
	ellenReply.addEventListener('play', function () {
	ellenReply.play();
	$(".replayButton").hide();
	}, false);
  }
});
$('.nonvimeo-close-info-modal').click(function() {
	$('.video-player-modal').removeClass('visible');
	$('body').removeClass('no-scroll');
	$('html').css("overflow-y", "visible");
	var pauseVideo = $(".non-vimeo-video").attr("id");
	$('video#'+pauseVideo).trigger('pause');
});

// Recommendation section carousel start

$(document).ready(function (){
  setTimeout (function (){
    if ($("#recommendation-section.product-grid .grid__item").length > 1) {
    if ($("#recommendation-section").hasClass('slick-initialized')) {
  		$("#recommendation-section").slick('unslick');
  	}
  	$("#recommendation-section").slick({
        dots: false,
		mobileFirst: true,
		autoplay: false,
		autoplaySpeed: 8000,
		arrows: true,
		infinite: true,
		cssEase: 'linear',
		centerMode: true,
		centerPadding: 0,
		speed: 750,
		slidesToShow: 1,
		responsive: [
        {
  			breakpoint: 640,
  			settings: {
  				slidesToShow: 1,
  				slidesToScroll: 1,
  			}
  		},{
  			breakpoint: 767,
  			settings: {
  				slidesToShow: 3,
  				slidesToScroll: 1,
  			}
  		}]
  	})

  }
  }, 3000);
});


$(document).ready(function (){
  $('.card__inner .card__media').on('mouseenter', function () {
    if ($(window).width() > 1024) {
  		$(this).find(".card-wrapper .card__content .quick-add.no-js-hidden").css({
  			opacity: '1'
  		});
  	}
  });
});

$('.grid-tile .product-image').on('mouseleave', function () {
	$("#quickviewbutton").remove();
	$(this).find(".card-wrapper .card__content .quick-add.no-js-hidden").css({
		opacity : '0'
	});
});


setTimeout(function(){

  if($('.product-included-section .slick-dots li').length > 1 ){
    $('.product-included-section .slick-dots').attr('style', 'display: block !important')
  };

},1500);

function pdpReadMore() {
	var readmoreLink=$('<span class="readmore-shortdescription-new"><p>Read More</p></span>');
	$('.product__description').append(readmoreLink);
	$(".product__description").each(function(){
		if($(this).height() < $(this)[0].scrollHeight){
		  $(this).parent().find(".readmore-shortdescription-new").show();
		  $(this).toggleClass("truncate");
		}
	  });
	  $(".readmore-shortdescription-new").click(function(){
        if($(this).parent().hasClass("truncate")) {
				$(this).parent().css("-webkit-line-clamp", 'inherit');
				$(this).children('p').text("Read Less");
			} else {
				$(this).parent().css("-webkit-line-clamp", "3");
				$(this).children('p').text("Read More");
			}
	  	$(this).parent().toggleClass("truncate");
	  });
}

// Initialize Slick slider only on mobile screens
function initSlickSlider() {
  if (typeof $.fn.slick !== "undefined") {
    $('.save-and-subscribe-slick').not('.slick-initialized').slick({
        autoplay: true,
        dots: true,
        arrows: false,
        infinite: true,
        speed: 2000,
        fade: false,
        cssEase: 'linear',
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 640,
                settings: "unslick"
            }
        ]
    });
  }
}

// Check if the screen width is less than 640 pixels
function isMobileScreen() {
    return $(window).width() < 640;
}

// Initialize Slick slider on page load if it's a mobile screen
if (isMobileScreen()) {
    initSlickSlider();
}

// Reinitialize Slick slider when the orientation changes or on window resize
$(window).on("orientationchange resize", function () {
    if (isMobileScreen()) {
        initSlickSlider();
    } else {
        try {
            $(".save-and-subscribe-slick").slick('unslick');
        } catch (e) {}
    }
});


$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

// sticky footer price update based on the window load
function stickyPriceUpdate() {
    var activeRadio = $('.rc-widget__root .rc-purchase-option__subscription.rc-purchase-option__selected, .rc-widget__root .rc-selection__onetime.rc-purchase-option__selected');
    if (activeRadio.length > 0) {
        var newPrice = $('.rc-price').html();
        $('.rc-purchase-option__selector:nth-child(1)').html();
        $(".sticky-footer-price").html("<strong>" + newPrice + "</strong>");
    }
}

// sticky footer price update based on the window load
$(window).on('load', function() {
  stickyPriceUpdate();
});

//Sticky header close menu on menuitem click
$('#shopify-section-lp-header a.list-menu__item').on('click', function(){
  $('.menu-drawer-container').removeClass('menu-opening');
  $('summary.header__icon').trigger('click');
});

$('#shopify-section-lp-tv-header a.list-menu__item').on('click', function(){
  $('.menu-drawer-container').removeClass('menu-opening');
  $('summary.header__icon').trigger('click');
});

$('#shopify-section-lp-emd-header a.list-menu__item').on('click', function(){
  $('.menu-drawer-container').removeClass('menu-opening');
  $('summary.header__icon').trigger('click');
});

$('#shopify-section-collection-based-header a.list-menu__item').on('click', function(){
  $('.menu-drawer-container').removeClass('menu-opening');
  $('summary.header__icon').trigger('click');
});


// sas page loader
$(document).ready(function() {

      $("#Search-In-Modal-1").keyup(function(){
    if($(this).val()!=""){
      $(".menu-drawer .search__button").prop("disabled",false)
    }else{
      $(".menu-drawer .search__button").prop("disabled",true)
    }
  });
  setTimeout(function() {
    $(".sas-page-kits-section").show();
    $(".checkout-button").show();
    $(".spinner-icon").hide();
  }, 100);
});
// pdp bottom sticky remove empty strike tag when tag has no strike value
function removepriceempty() {
    $('.sticky-footer-price s').filter(function() {
        return $(this).text().trim() === '';
      }).remove();
}
$(document).ready(function() {
      setInterval(removepriceempty,1000);
});

if(window.location.href.includes('mbglink')){
      $('.grid__item #mbglink details').attr('open', 'open');
      $(".sas-feature-section-block-wrapper a:eq(2)").addClass("active");
}

    document.addEventListener("DOMContentLoaded", function () {
      function revealSections() {
        const sections = document.querySelectorAll(".preload");

        sections.forEach(section => {
          const rect = section.getBoundingClientRect();
          const sectionVisible = rect.top < window.innerHeight && rect.bottom > 0; // Checks for partial visibility
          if (sectionVisible) {
            section.classList.add("visible");
          }
        });
      }

      // Run on scroll and resize
      window.addEventListener("scroll", revealSections);
      window.addEventListener("resize", revealSections);

      // Run on initial load
      revealSections();
    });


    window.onload = function () {
      setTimeout(() => {
    const preloadDivs = document.querySelectorAll(".preload");
    function isPartiallyInViewport(element) {
        const rect = element.getBoundingClientRect();
        return (
            rect.top < window.innerHeight &&
            rect.bottom > 0 &&
            rect.left < window.innerWidth &&
            rect.right > 0
        );
    }
    preloadDivs.forEach(div => {
        if (isPartiallyInViewport(div)) {
          div.classList.add("visible");
          div.classList.remove("preload");
        }
    });

      }, 0);
  };

if (
  $('.sas-page-kits-section').length > 0 ||
  $('.preupsell-section').length > 0
) {
    document.addEventListener("DOMContentLoaded", function () {
      if (typeof klaviyo !== 'undefined' && typeof klaviyo.push === 'function') {

        function updateKitData(event) {
          const clickedButton = event?.target;

          // Clean URL and query parameters
          const fullUrl = window.location.href;
          const urlObj = new URL(fullUrl);
          const cleanUrl = urlObj.origin + urlObj.pathname;
          const pageName = document.title || "Unknown Page";
          const queryParams = {};

          for (const [key, value] of urlObj.searchParams.entries()) {
            queryParams[key] = value;
          }

          let kitName = "Default Kit Name";
          let kitImageUrl = "https://kindscience.com/cdn/shop/files/Kind_Science_Logo_byellen.png";

          if (fullUrl.includes('/preupsell')) {
            const variantTitleElement = document.querySelector('.selected-cart-product-title');
            const variantImageElement = document.querySelector('.selected-cart-product-image');
            const titleValue = variantTitleElement?.value?.trim();
            const imageValue = variantImageElement?.value?.trim();
            if (titleValue) kitName = titleValue;
            if (imageValue) kitImageUrl = imageValue.startsWith('//') ? 'https:' + imageValue : imageValue;
          }
          const selectedKit = document.querySelector('.sas-page-kit.active.selected');
          if (selectedKit) {
            const variantTitleElement = selectedKit.querySelector('.selected-variant-title');
            const variantImageElement = selectedKit.querySelector('.selected-variant-image');
            if (variantTitleElement) kitName = variantTitleElement.value || kitName;
            if (variantImageElement) {
              let rawImageUrl = variantImageElement.value;
              kitImageUrl = rawImageUrl?.startsWith('//') ? 'https:' + rawImageUrl : (rawImageUrl || kitImageUrl);
            }
          } else if (clickedButton) {
            const buttonClasses = clickedButton.classList;
            const isNoThanks = buttonClasses.contains('no-thanks') || buttonClasses.contains('btn-no-upgrade');

            if (isNoThanks) {
              const titleValue = document.querySelector('.selected-cart-product-title')?.value?.trim();
              const imageValue = document.querySelector('.selected-cart-product-image')?.value?.trim();
              if (titleValue) kitName = titleValue;
              if (imageValue) kitImageUrl = imageValue.startsWith('//') ? 'https:' + imageValue : imageValue;
            } else {
              const variantTitleElement = document.querySelector('.selected-variant-title');
              const variantImageElement = document.querySelector('.selected-variant-image');

              if (variantTitleElement) {
                kitName = variantTitleElement.value || kitName;
              } else {
                kitName = clickedButton.textContent.trim() || kitName;
              }

              if (variantImageElement) {
                let rawImageUrl = variantImageElement.value;
                kitImageUrl = rawImageUrl?.startsWith('//') ? 'https:' + rawImageUrl : (rawImageUrl || kitImageUrl);
              }
            }
          }

          const klaviyoData = {
            CleanURL: cleanUrl,
            PageName: pageName,
            KitName: kitName,
            KitImageURL: kitImageUrl,
            ...queryParams
          };
          console.log("Klaviyo push data:", klaviyoData);
          klaviyo.push(['track', 'Page View', klaviyoData]);
        }

        setTimeout(() => {
          updateKitData(); // Run on load
        }, 900);

        document.body.addEventListener('click', function (event) {
          const clickedButton = event.target;
          const classCombinations = [
            ['sas-kit-cta'],
            ['preupsell-cta'],
            ['no-thanks'],
            ['btn-upgrade'],
            ['btn-no-upgrade'],
            ['checkout-sas-kit-cta']
          ];

          const matches = classCombinations.some(classList =>
            classList.every(className => clickedButton.classList.contains(className))
          );

          if (matches) {
            updateKitData(event);
          }
        });

      } else {

      }
    });

  }

// Combined selector for both sets of links
const menuLinks = document.querySelectorAll(
  '.logged-in-user #Details-menu-drawer-menu-item-4 .menu-drawer__menu a, ' +
  '#menu-drawer .menu-drawer__menu.has-submenu.list-menu li a'
);

menuLinks.forEach(link => {
  link.addEventListener('click', () => {
    const detailsEl = document.getElementById('details-menu-drawer-container');
    const summaryEl = detailsEl?.querySelector('summary');

    // Close the drawer
    detailsEl?.classList.remove('menu-opening');
    detailsEl?.removeAttribute('open');

    // Update accessibility attribute
    if (summaryEl) {
      summaryEl.setAttribute('aria-expanded', 'false');
    }

    // Enable scrolling on tablet
    document.body.classList.remove('overflow-hidden-tablet');
  });
});


$('summary.header__icon').on('click', function() {
    setTimeout(function() {
      const cnt = $('.menu-drawer-container.menu-opening').length;
      if (cnt == 0) {
        $('summary.header__icon--menu').attr('aria-expanded', 'false');
      }
    }, 50);
  });

  /*startker kit product discount price hide*/
$(document).ajaxComplete(function() {
  setTimeout(function() {
    if (
      $('.hs-product-45223361347800').length > 0 ||
      $('.hs-product-41807023800379').length > 0
    ) {
      $('.hs-site-cart-popup-layout').addClass('starter-kit-slide-cart-section');
    }
  }, 2000);
});

document.addEventListener("DOMContentLoaded", () => {
  /* RUN ONLY FOR THIS BODY CLASS */
const body = document.body;

if (
  !body.classList.contains('core-campaign') &&
  !body.classList.contains('spl-tv-trio-fs-campaign') &&
  !body.classList.contains('tv-corecb-campaign') &&
  !body.classList.contains('spl-pdp-trio2-campaign') &&
  !body.classList.contains('spl-tv-trio-campaign') &&
  !body.classList.contains('spl-rcl-campaign') &&
  !body.classList.contains('spl-rclv2-campaign') &&
  !body.classList.contains('spl-or-cfg-campaign') &&
  !body.classList.contains('tv-coresi-campaign') &&
  !body.classList.contains('spl-or-holiday-campaign') &&
  !body.classList.contains('spl-or-summer-campaign') &&
  !body.classList.contains('spl-or-holiday-fs-campaign') &&
  !body.classList.contains('spl-or-july-campaign') &&
  !body.classList.contains('spl-or-pink-campaign') &&
  !body.classList.contains('spl-or-green-campaign') &&
  !body.classList.contains('spl-or-holiday-mm15-campaign') &&
  !body.classList.contains('spl-or-mds-campaign') &&
  !body.classList.contains('spl-tv-do-campaign') &&
  !body.classList.contains('spl-or-md30-campaign') &&
  !body.classList.contains('spl-pdp-wfs-campaign') &&
  !body.classList.contains('spl-tv-do-cb-campaign')
) {
  return;
}

  const countdownSection = document.querySelector('.countdown-timer-section-1');
  const offerModal = document.querySelector('.ps-offer-model');
  const timerEls = document.querySelectorAll('.count-timer-block');
  const stickyFooter = document.querySelector('.lp-sticky-footer');

  if (!offerModal) return;

  /* FORCE HIDE IMMEDIATELY (ANTI FLASH) */
  offerModal.classList.add("hide");
  offerModal.setAttribute("aria-hidden", "true");

  /* UNIQUE KEY (PER PAGE) */
  const PAGE_KEY = window.location.pathname;

  // User should see countdown ONLY ONCE
  const OFFER_KEY = `ps_offer_seen_${PAGE_KEY}`;

  /* HELPERS */
  function hasSeenOffer() {
    return sessionStorage.getItem(OFFER_KEY) === "true" ||
           localStorage.getItem(OFFER_KEY) === "true";
  }

  function markOfferAsSeen() {
    // sessionStorage = current tab session
    sessionStorage.setItem(OFFER_KEY, "true");

    // localStorage = persists after refresh/reload
    localStorage.setItem(OFFER_KEY, "true");
  }

  function hasUserClosedModal() {
    return document.cookie.indexOf("PsOfferModel=true") > -1;
  }

  // function showModal() {
  //   if (hasUserClosedModal()) return;

  //   stickyFooter?.classList.add("hide");

  //   offerModal.classList.add("enter-slide-right");
  //   offerModal.classList.remove("hide");
  //   offerModal.setAttribute("aria-hidden", "false");
  // }

  function showModal() {
  if (hasUserClosedModal()) return;

  stickyFooter?.classList.add("hide");

  offerModal.classList.add("show");
  offerModal.classList.remove("hide");
  offerModal.setAttribute("aria-hidden", "false");
}

  function hideModal(hard = false) {
    offerModal.classList.add("hide");
    stickyFooter?.classList.remove("hide");

    if (hard) {
      offerModal.setAttribute("data-expired", "true");
      offerModal.setAttribute("aria-hidden", "true");
    }
  }

  /* SHOW ONLY FIRST TIME */
  if (hasSeenOffer()) {
    countdownSection?.classList.add("hide");
    hideModal(true);
    return;
  }

  // Mark immediately after first load
  markOfferAsSeen();

  /*  SCROLL TRIGGER */
  let scrollTriggered = false;

  $(window).on("scroll", function () {

    if (scrollTriggered) return;

    if ($(this).scrollTop() >= 600) {
      scrollTriggered = true;
      showModal();
    }
  });

  /* COUNTDOWN TIMER */
  if (timerEls.length) {

    let timeLeft = 5 * 60;

    const countdownInterval = setInterval(() => {

      const minutes = Math.floor(timeLeft / 60);
      const seconds = timeLeft % 60;

      timerEls.forEach(el => {
        el.textContent =
          `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      });

      if (timeLeft <= 0) {

        clearInterval(countdownInterval);

        countdownSection?.classList.add("hide");

        hideModal(true);

        return;
      }

      timeLeft--;

    }, 1000);
  }

  /* CLOSE BUTTON */
  $(".offer-close-model").on("click", function () {

    hideModal();

    document.cookie = "PsOfferModel=true; path=/;";
  });

});

// document.addEventListener("DOMContentLoaded", () => {
//   const countdownSection = document.querySelector('.countdown-timer-section');
//   const offerModal = document.querySelector('.ps-offer-model');
//   const timerEls = document.querySelectorAll('.count-timer-block');
//   const stickyFooter = document.querySelector('.lp-sticky-footer');

//   if (!offerModal) return;

//   /* ===============================
//      FORCE HIDE IMMEDIATELY (ANTI FLASH)
//      =============================== */
//   offerModal.classList.add("hide");
//   offerModal.setAttribute("aria-hidden", "true");

//   /* ===============================
//      UNIQUE KEY (PER LP + DAY)
//      =============================== */
//   const PAGE_KEY = window.location.pathname;
//   const TODAY = new Date().toISOString().split("T")[0];
//   const OFFER_KEY = `ps_offer_expired_${PAGE_KEY}_${TODAY}`;
//   const SPECIAL_EXPIRED_KEY = `ps_special_lp_expired_${TODAY}`;

//   /* ===============================
//      SPECIAL LP FLAG
//      =============================== */
//   const SPECIAL_LP_URLS = [
//   "/pages/lp-spl-or-nwf",
//   "/pages/lp-spl-or-nwf2",
//   "/pages/lp-spl-or-nwf-10"
// ];

// const SPECIAL_LP = SPECIAL_LP_URLS.includes(PAGE_KEY);

//   /* ===============================
//      HELPERS
//      =============================== */
//   function isOfferExpired() {
//     return localStorage.getItem(OFFER_KEY) === "true";
//   }

//   function expireOfferForToday() {
//     localStorage.setItem(OFFER_KEY, "true");
//   }

//   function isSpecialExpired() {
//     return localStorage.getItem(SPECIAL_EXPIRED_KEY) === "true";
//   }

//   function expireSpecialLP() {
//     localStorage.setItem(SPECIAL_EXPIRED_KEY, "true");
//   }

//   function hasUserClosedModal() {
//     return document.cookie.indexOf("PsOfferModel=true") > -1;
//   }

//   function showModal() {
//     if (hasUserClosedModal()) return;

//     stickyFooter?.classList.add("hide");
//     offerModal.classList.add("enter-slide-right");
//     offerModal.classList.remove("hide");
//     offerModal.setAttribute("aria-hidden", "false");
//   }

//   function hideModal(hard = false) {
//     offerModal.classList.add("hide");
//     stickyFooter?.classList.remove("hide");

//     if (hard) {
//       offerModal.setAttribute("data-expired", "true");
//       offerModal.setAttribute("aria-hidden", "true");
//     }
//   }

//   /* ===============================
//      HANDLE PAGE LOAD STATE
//      =============================== */

//   // ✅ Special LP → expired already → show modal, hide timer
//   if (SPECIAL_LP && isSpecialExpired()) {
//     countdownSection?.classList.add("hide");
//     showModal();
//     return;
//   }

//   // ✅ Normal LP → expired → hide everything
//   const OFFER_EXPIRED =
//     isOfferExpired() || offerModal.getAttribute("data-expired") === "true";

//   if (OFFER_EXPIRED && !SPECIAL_LP) {
//     countdownSection?.classList.add("hide");
//     hideModal(true);
//     return;
//   }

//   /* ===============================
//      SCROLL TRIGGER
//      =============================== */
//   let scrollTriggered = false;

//   $(window).on("scroll", function () {
//     if (scrollTriggered) return;

//     if ($(this).scrollTop() >= 600) {
//       scrollTriggered = true;
//       showModal();
//     }
//   });

//   /* ===============================
//      COUNTDOWN TIMER
//      =============================== */
//   if (timerEls.length) {
//     let timeLeft = 5 * 60; // 30 seconds

//     const countdownInterval = setInterval(() => {
//       const minutes = Math.floor(timeLeft / 60);
//       const seconds = timeLeft % 60;

//       timerEls.forEach(el => {
//         el.textContent =
//           `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
//       });

//       if (timeLeft <= 0) {
//         clearInterval(countdownInterval);

//         countdownSection?.classList.add("hide");

//         if (SPECIAL_LP) {
//           // ✅ Persist special LP expired state
//           expireSpecialLP();
//           showModal();
//         } else {
//           expireOfferForToday();
//           hideModal(true);
//         }

//         return;
//       }

//       timeLeft--;
//     }, 1000);
//   }

//   /* ===============================
//      CLOSE BUTTON
//      =============================== */
//   $(".offer-close-model").on("click", function () {
//     hideModal();
//     document.cookie = "PsOfferModel=true; path=/;";
//   });

// });


// $(document).ready(function() {
//   if ($(window).width() > 768) {
//     setTimeout(function() {
//       // Target the specific <li> element
// var productIds = ['7995261321432', '7103778291771'];
// var targetLi = productIds
//   .map(id => `li.grid__item.kit-product.property-fg[data-productid='${id}']`)
//   .join(', ');
// targetLi = $(targetLi);

//       if (targetLi.length > 0) {
//         var customDiv = `
//         <li class="grid__item kit-product property-fg holiday-bg hide-for-small-only">
//         <div class="holiday-image-column">
//           </div>

//         </li>
//         `;

//         // Insert the custom div after the target <li>
//         targetLi.after(customDiv);
//       }
//     }, 1500);
//   }
// });

$(document).ready(function() {
  const pathname = window.location.pathname;
  if (pathname === "/pages/preupsell-pdp-winback") {
    $(".brand-header.header-bg-wrapper.header-wrapper.gradient.default-header")
      .addClass("preupsell-pdp-winback-header");
    $(".announcement-bar__link").addClass("hide");
    $("body").addClass("preupsell-pdp-winback");
  }
});

$(function() {
  setTimeout(function() {
    $(
      ".pdp-7480066834491 .recharge-subscription-widget, " +
      ".pdp-7480071290939 .recharge-subscription-widget, " +
      ".pdp-7480072765499 .recharge-subscription-widget, " +
      ".pdp-7480074108987 .recharge-subscription-widget, " +
      ".pdp-7480125325371 .recharge-subscription-widget, " +
      ".pdp-7480126439483 .recharge-subscription-widget, " +
      ".pdp-9024559579352 .recharge-subscription-widget, " +
      ".pdp-9023289163992 .recharge-subscription-widget, " +
      ".pdp-9031019823320 .recharge-subscription-widget, " +
      ".pdp-9031017758936 .recharge-subscription-widget, " +
      ".pdp-9031009501400 .recharge-subscription-widget, " +
      ".pdp-9031020314840 .recharge-subscription-widget"
    ).css("visibility", "visible");
  }, 2500);
});

$(document).ajaxComplete(function() {
  setTimeout(function() {
    if (
      $('.hs-product-42584672075835').length > 0 ||
      $('.hs-product-42584766742587').length > 0 ||
      $('.hs-product-42584773066811').length > 0 ||
      $('.hs-product-42584645992507').length > 0 ||
      $('.hs-product-42584688164923').length > 0 ||
      $('.hs-product-42584677154875').length > 0 ||
      $('.hs-product-50925658898648').length > 0 ||
      $('.hs-product-50925699301592').length > 0 ||
      $('.hs-product-50906184581336').length > 0 ||
      $('.hs-product-50925700776152').length > 0 ||
      $('.hs-product-50899937165528').length > 0 ||
      $('.hs-product-50925693796568').length > 0
    ) {
      $('.hs-site-cart-popup-layout').addClass('holiday-prospects-section');
    }
  }, 2000);
});

$(document).ajaxComplete(function() {
  setTimeout(function() {
    if (
      $('.hs-product-41412963008571').length > 0 ||
      $('.hs-product-42584812716091').length > 0 ||
      $('.hs-product-42584813731899').length > 0 ||
      $('.hs-product-42584813862971').length > 0 ||
      $('.hs-product-42584813895739').length > 0 ||
      $('.hs-product-42584813928507').length > 0 ||
      $('.hs-product-42584813961275').length > 0 ||
      $('.hs-product-42584814190651').length > 0 ||
      $('.hs-product-42584814223419').length > 0
    ) {
      $('.hs-site-cart-popup-layout').addClass('wb-holiday-shop-section');
    }
	  }, 2000);
});

$(document).ready(function() {
  // When user clicks "See Details"
  $('.see-details-offer-text').on('click', function() {
    $(this).addClass('active');
  });

  // When modal is closed
  $('#see-details-modal').on('hidden.bs.modal', function() {
    $(this).closest(".rc-purchase-option__subscription").trigger("click");
    $('.see-details-offer-text').removeClass('active');
  });
});


$(document).ready(function() {
  const pathname = window.location.pathname;
  if (pathname === "/pages/faq-customer-service") {
    $(".our-promise-section-fluid").addClass("hide");
  }
});

(() => {
  const ATTR = "data-keep-aria-label";

  // mark elements you want protected
  document.querySelectorAll(`[${ATTR}]`).forEach(el => {
    const val = el.getAttribute("aria-label");
    if (val) el.dataset.keepAriaLabelValue = val;
  });

  const restore = (el) => {
    const desired = el.dataset.keepAriaLabelValue;
    if (desired && el.getAttribute("aria-label") !== desired) {
      el.setAttribute("aria-label", desired);
    }
  };

  const obs = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === "attributes" && m.attributeName === "aria-label") {
        const el = m.target;
        if (el && el.hasAttribute(ATTR)) restore(el);
      }
    }
  });

  document.querySelectorAll(`[${ATTR}]`).forEach(el => {
    obs.observe(el, { attributes: true, attributeFilter: ["aria-label"] });
    restore(el);
  });
})();

// document.addEventListener("DOMContentLoaded", function () {
//   const url = window.location.href;

//   if (url.includes("shop-deals")) {
//     document.body.classList.add("shop-deals-ellen");
//   }
// });

// document.addEventListener("DOMContentLoaded", function () {
//   const isShopDeal = window.location.href.includes("shop-deals");
//   if (!isShopDeal) return;
//   document.body.classList.add("shop-deals-ellen");
//   let triggered = false;
//   const interval = setInterval(() => {
//     const oneTimeRadio = document.querySelector(
//       ".rc-widget__root .rc-selection__onetime input, .rc-widget__root .rc-selection__onetime"
//     );

//     if (oneTimeRadio && !triggered) {
//       oneTimeRadio.click();
//       oneTimeRadio.dispatchEvent(new Event("change", { bubbles: true }));

//       triggered = true;
//       clearInterval(interval);
//     }
//   }, 3000);
// });


(function () {
  const originalFetch = window.fetch;

  window.fetch = function () {
    return originalFetch.apply(this, arguments).then(async response => {
      if (response.url.includes('/cart/change') ||
          response.url.includes('/cart/add') ||
          response.url.includes('/cart/update')) {

        try {
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();

          const srCount = document.getElementById('CartCountSR');
          if (srCount) {
            srCount.textContent =
              `${cart.item_count} item${cart.item_count === 1 ? '' : 's'}`;
          }
        } catch (e) {
          console.warn('Cart SR update failed', e);
        }
      }

      return response;
    });
  };
})();


document.addEventListener("DOMContentLoaded", function () {
  // Check body class first
  if (!document.body.classList.contains("tv-coresi-campaign") && !document.body.classList.contains("core-campaign") && !document.body.classList.contains("spl-or-cfg-campaign")) {
    return;
  }
  // Select CTA only inside countdown section
  const kitCtaBtn = document.querySelector(
    ".countdown-timer-section .trigger-block-cta-content"
  );
  if (!kitCtaBtn) {
    return;
  }
  kitCtaBtn.addEventListener("click", function (e) {
    e.preventDefault();
    const targetBtn = document.querySelector(
      ".block-cta.btm-billboard-preusell"
    );

    if (targetBtn) {
      targetBtn.click();
    }
  });

});

 // Maven chat widget integration for pre-chat form with email and billing zip validation
 // Maven Clean PROD

// document.addEventListener('DOMContentLoaded', function () {
//     const form = document.querySelector('.maven-popup-form');
//     if (!form) return;

//     const emailInput = form.querySelector('input[name="email"]');
//     const zipInput = form.querySelector('input[name="billing_zip"]');
//     const submitBtn = form.querySelector('.support-popup__btn');

//     const emailError = form.querySelector('.email-error');
//     const zipError = form.querySelector('.zip-error');
//     const formError = form.querySelector('.form-error');

//     function clearErrors() {
//       if (emailError) emailError.textContent = '';
//       if (zipError) zipError.textContent = '';
//       if (formError) formError.textContent = '';
//     }

//     function showError(message, type) {
//       if (type === 'email' && emailError) {
//         emailError.textContent = message;
//       } else if (type === 'zip' && zipError) {
//         zipError.textContent = message;
//       } else if (formError) {
//         formError.textContent = message;
//       }
//     }

//     function normalizeEmail(value) {
//       return String(value || '').trim().toLowerCase();
//     }

//     function normalizeZip(value) {
//       return String(value || '').trim();
//     }

//     function openMavenPopup() {
//       try {
//         if (!window.Maven || !window.Maven.ChatWidget) return;

//         // Try common open methods if available
//         if (typeof window.Maven.ChatWidget.open === 'function') {
//           window.Maven.ChatWidget.open();
//           return;
//         }

//         if (typeof window.Maven.ChatWidget.show === 'function') {
//           window.Maven.ChatWidget.show();
//           return;
//         }

//         if (typeof window.Maven.ChatWidget.toggle === 'function') {
//           window.Maven.ChatWidget.toggle(true);
//           return;
//         }

//         // Fallback: try clicking launcher button if Maven injects one
//         const launcher =
//           document.querySelector('[data-maven-chat-launcher]') ||
//           document.querySelector('.maven-chat-launcher') ||
//           document.querySelector('.maven-widget-launcher') ||
//           document.querySelector('button[aria-label*="chat" i]');

//         if (launcher) {
//           launcher.click();
//         }
//       } catch (err) {
//         console.error('Error while opening Maven popup:', err);
//       }
//     }

//     form.addEventListener('submit', async function (e) {
//       e.preventDefault();
//       clearErrors();

//       if (!form.checkValidity()) {
//         form.reportValidity();
//         return;
//       }

//       const email = emailInput.value.trim();
//       const billingZip = zipInput.value.trim();

//       submitBtn.disabled = true;
//       submitBtn.textContent = 'Please wait...';

//       try {
//         const res = await fetch('/tools/proxy/signed-user-data', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             'Accept': 'application/json',
//             'X-Organization-Id': 'kindscience',
//            // 'X-Agent-Id': 'ksclean',
//            'X-Agent-Id': 'ksclean'
//           },
//           credentials: 'same-origin',
//           body: JSON.stringify({
//             email: email,
//             billing_zip: billingZip
//           })
//         });

//         const data = await res.json().catch(() => ({}));
//         console.log('API response:', data);

//         if (!res.ok) {
//           const errorMessage =
//             data.error ||
//             data.message ||
//             `Request failed with status ${res.status}`;

//           showError(errorMessage);
//           return;
//         }

//         const apiCustomer = data.customer || data.user || data.data || {};
//         const apiEmail = normalizeEmail(
//           apiCustomer.email || data.email
//         );
//         const apiZip = normalizeZip(
//           apiCustomer.billing_zip ||
//           apiCustomer.billingZip ||
//           apiCustomer.zip ||
//           data.billing_zip ||
//           data.billingZip ||
//           data.zip
//         );

//         const enteredEmail = normalizeEmail(email);
//         const enteredZip = normalizeZip(billingZip);

//         if (apiEmail && apiEmail !== enteredEmail) {
//           showError('Entered email does not match our records.', 'email');
//           return;
//         }

//         if (apiZip && apiZip !== enteredZip) {
//           showError('Entered billing zip code does not match our records.', 'zip');
//           return;
//         }

//         if (!data.token) {
//           showError('Unable to load chat. Token not received.');
//           return;
//         }

//         if (window.Maven && window.Maven.ChatWidget) {
//           window.Maven.ChatWidget.load({
//             organizationId: 'kindscience',
//             agentId: 'ksclean',
//             //agentId: 'ksprod-v1',
//             bgColor: "#1f386b",
//             showPoweredBy: false,
//             signedUserData: data.token
//           });

//           const modalEl = document.getElementById('maven-login-info-popup');
//           if (window.jQuery && modalEl) {
//             window.jQuery(modalEl).modal('hide');
//           }

//           // Give widget a moment to initialize, then open it
//           setTimeout(function () {
//             openMavenPopup();
//           }, 800);
//         } else {
//           showError('Chat widget script is not loaded.');
//         }
//       } catch (error) {
//         console.error('Request error:', error);
//         showError('Something went wrong. Please try again.');
//       } finally {
//         submitBtn.disabled = false;
//         submitBtn.textContent = 'GET STARTED';
//       }
//     });

//     emailInput.addEventListener('input', clearErrors);
//     zipInput.addEventListener('input', clearErrors);
//   });

  // Maven Charter-Clean PROD
document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('.maven-popup-form-charters');
  if (!form) return;

  const emailInput = form.querySelector('input[name="email"]');
  const zipInput = form.querySelector('input[name="billing_zip"]');
  const submitBtn = form.querySelector('.support-popup__btn');

  const emailError = form.querySelector('.email-error');
  const zipError = form.querySelector('.zip-error');
  const formError = form.querySelector('.form-error');

  function clearErrors() {
    if (emailError) emailError.textContent = '';
    if (zipError) zipError.textContent = '';
    if (formError) formError.textContent = '';
  }

  function showError(message, type) {
    if (type === 'email' && emailError) {
      emailError.textContent = message;
    } else if (type === 'zip' && zipError) {
      zipError.textContent = message;
    } else if (formError) {
      formError.textContent = message;
    }
  }

  function normalizeEmail(value) {
    return String(value || '').trim().toLowerCase();
  }

  function normalizeZip(value) {
    return String(value || '').trim();
  }

  function openMavenPopup() {
    try {
      if (!window.Maven || !window.Maven.ChatWidget) return;

      // Try common open methods if available
      if (typeof window.Maven.ChatWidget.open === 'function') {
        window.Maven.ChatWidget.open();
        return;
      }

      if (typeof window.Maven.ChatWidget.show === 'function') {
        window.Maven.ChatWidget.show();
        return;
      }

      if (typeof window.Maven.ChatWidget.toggle === 'function') {
        window.Maven.ChatWidget.toggle(true);
        return;
      }

      // Fallback: try clicking launcher button if Maven injects one
      const launcher =
        document.querySelector('[data-maven-chat-launcher]') ||
        document.querySelector('.maven-chat-launcher') ||
        document.querySelector('.maven-widget-launcher') ||
        document.querySelector('button[aria-label*="chat" i]');

      if (launcher) {
        launcher.click();
      }
    } catch (err) {
      console.error('Error while opening Maven popup:', err);
    }
  }

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    clearErrors();

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const email = emailInput.value.trim();
    const billingZip = zipInput.value.trim();

    submitBtn.disabled = true;
    submitBtn.textContent = 'Please wait...';

    try {
      const res = await fetch('/tools/charters-prod-proxy/signed-user-data', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Organization-Id': 'kindscience',
          'X-Agent-Id': 'ksprod-v1'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          email: email,
          billing_zip: billingZip
        })
      });

      const data = await res.json().catch(() => ({}));
      console.log('API response:', data);

      if (!res.ok) {
        const errorMessage =
          data.error ||
          data.message ||
          `Request failed with status ${res.status}`;

        showError(errorMessage);
        return;
      }

      const apiCustomer = data.customer || data.user || data.data || {};
      const apiEmail = normalizeEmail(
        apiCustomer.email || data.email
      );
      const apiZip = normalizeZip(
        apiCustomer.billing_zip ||
        apiCustomer.billingZip ||
        apiCustomer.zip ||
        data.billing_zip ||
        data.billingZip ||
        data.zip
      );

      const enteredEmail = normalizeEmail(email);
      const enteredZip = normalizeZip(billingZip);

      if (apiEmail && apiEmail !== enteredEmail) {
        showError('Entered email does not match our records.', 'email');
        return;
      }

      if (apiZip && apiZip !== enteredZip) {
        showError('Entered billing zip code does not match our records.', 'zip');
        return;
      }

      if (!data.token) {
        showError('Unable to load chat. Token not received.');
        return;
      }

      if (window.Maven && window.Maven.ChatWidget) {
        window.Maven.ChatWidget.load({
          organizationId: 'kindscience',
          agentId: 'ksprod-v1',
          bgColor: "#1f386b",
          showPoweredBy: false,
          signedUserData: data.token

        });

        const modalEl = document.getElementById('maven-login-info-popup-charters');
        if (window.jQuery && modalEl) {
          window.jQuery(modalEl).modal('hide');
        }

        // Give widget a moment to initialize, then open it
        setTimeout(function () {
          openMavenPopup();
        }, 800);
      } else {
        showError('Chat widget script is not loaded.');
      }
    } catch (error) {
      console.error('Request error:', error);
      showError('Something went wrong. Please try again.');
    } finally {
      submitBtn.disabled = false;
      submitBtn.textContent = 'GET STARTED';
    }
  });

  emailInput.addEventListener('input', clearErrors);
  zipInput.addEventListener('input', clearErrors);
});

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.signupnew-splash-body')) {
      document.body.classList.add('signupnew-splash');
  }
});

window.addEventListener('klaviyoForms', function (e) {
  if (e.detail.type === 'submit') {
    fbq('track', 'Lead', {
      content_name: 'Newsletter Signup',
      content_category: 'sign-up-new'
    });
  }
});


// document.addEventListener('click', function (e) {
//   console.log("fdsfsf");
//   const trigger = e.target.closest('recharge-subscription-widget[part="rc-learn-more__trigger"]');
//  console.log("fdsfsf-tertr", trigger);
//   if (!trigger) return;

//   setTimeout(() => {
//      console.log("fdsfsf-settimout");
//     const modal = document.querySelector('rc-learn-more-modal');

//     if (!modal?.shadowRoot) return;

//     const footer = modal.shadowRoot.querySelector('.rc-modal-content__footer');

//     if (footer) {
//       footer.style.setProperty('display', 'none', 'important');
//     }
//   }, 100);
// });

(function () {
  function hideRechargeLearnMoreFooter() {
    const modal = document.querySelector('rc-learn-more-modal');

    if (!modal || !modal.shadowRoot) return;

    if (modal.shadowRoot.querySelector('#hide-recharge-footer')) return;

    const style = document.createElement('style');
    style.id = 'hide-recharge-footer';

    style.textContent = `
      .rc-modal-content__footer {
        display: none !important;
      }
    `;

    modal.shadowRoot.appendChild(style);
  }

  hideRechargeLearnMoreFooter();

  const observer = new MutationObserver(function () {
    hideRechargeLearnMoreFooter();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();